import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { ETimeFormat, ETimeNumericFormat, dateTimeHelper } from '@cf/core';
import { TimezoneNamePipe } from '@cf/shared/forms/timezone-select';
import { LinkComponent } from '@cf/shared/ui/button';
import { CfIconDirective } from '@cf/shared/ui/icons';
import { CurrentTimePipe, DateFormatPipe, TextComponent } from '@cf/shared/ui/typography';
import { EMeetingTool, ReverseEMeetingTool, SchemaAppEventLocation } from '@cf/temp/services';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
  selector: 'cf-booking-information',
  templateUrl: './booking-information.component.html',
  styleUrls: ['./booking-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgxTolgeeModule,
    TextComponent,
    DateFormatPipe,
    CommonModule,
    LinkComponent,
    TimezoneNamePipe,
    CurrentTimePipe,
    CfIconDirective,
  ],
})
export class BookingInformationComponent {
  @Input({ required: true }) timezone!: string;

  @Input({ required: true }) time!: string;

  @Input({ required: true }) day!: string;

  @Input({ required: false }) oldDuration!: string;

  @Input({ required: false }) oldTime!: string;

  @Input({ required: false }) oldDay!: string;

  @Input({ required: true }) duration!: string;

  @Input() participantsTmp!: TemplateRef<any> | null;

  @Input() location!: SchemaAppEventLocation;

  @Input() label!: string;

  @Input() direction: 'row' | 'column' = 'column';

  readonly EMeetingTool = EMeetingTool;
  readonly ReverseEMeetingTool = ReverseEMeetingTool;

  get meetingToolName() {
    if (!this.location.meeting_tool) {
      return '';
    }
    return ReverseEMeetingTool[this.location.meeting_tool];
  }

  get timeFormat() {
    if (!this.time) {
      return 12;
    }
    return dateTimeHelper.isValidFormat(this.time, ETimeFormat.TIME_24) ? 24 : 12;
  }

  timeTo(time = this.time, duration = this.duration) {
    const timeFormat: ETimeNumericFormat = dateTimeHelper.isValidFormat(time, ETimeFormat.TIME_24)
      ? ETimeNumericFormat.TIME_24
      : ETimeNumericFormat.TIME_12;

    return dateTimeHelper.getTimeFromDate(
      dateTimeHelper.getDateFromTime(time, true).plus({ minute: +duration }),
      timeFormat,
    );
  }
}
